import { IPromise } from 'q';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Messages } from '../../../codegen/Localize';
import { SiteStore } from '../../../common/react/SiteStore';
import { SiteNameSansIds } from '../../../ts/resources/SiteNameSansIds';
import { ISiteNameSansId } from '../../../ts/ServerApi/types/ISiteNameSansId';
import { SiteNamesRequest } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { SiteNamesRequestAction, siteNamesRequestSucceeded } from '../../actions/spaces/SitesNamesRequestAction';
import { ServiceLocator } from '../../ServiceLocator';

export function* handleGetSitesRequest(action: SiteNamesRequestAction) {
  try {
    const sites: ReadonlyArray<ISiteNameSansId> = yield call(getSiteNamesRequest);
    yield put(siteNamesRequestSucceeded(sites));
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function getSiteNamesRequest(): IPromise<ISiteNameSansId[]> {
  const sitesResource = ServiceLocator.get<SiteNameSansIds>('SiteNamesAcrossAllPods');
  const siteStore = new SiteStore(sitesResource);
  return siteStore.getAll();
}

export function* rootSiteSagas(): SagaIterator {
  yield takeLatest(SiteNamesRequest, handleGetSitesRequest);
}

